import { useMemo } from 'react';
import { CascadingFilter } from '@/components/CascadingFilter';
import {
  HEATMAP_TIMEZONE_COUNTRIES,
  heatmapTimezoneClosedLabel,
} from '@/lib/heatmapTimezones';
import { withUtcOffsetInLabel } from '@/lib/timezoneOffsetLabel';

export function TimezoneCountryStateFilter({
  timezone,
  onTimezoneChange,
  ariaLabel = 'Change timezone',
  className,
  detail = 'Timezone',
}: {
  timezone: string;
  onTimezoneChange: (timezone: string) => void;
  ariaLabel?: string;
  className?: string;
  detail?: string;
}) {
  const groups = useMemo(
    () =>
      HEATMAP_TIMEZONE_COUNTRIES.map((country) => ({
        value: country.value,
        label: country.label,
        ...(country.regions.length > 0
          ? {
              children: country.regions.map((region) => ({
                value: region.value,
                label: withUtcOffsetInLabel(region.label, region.value),
              })),
            }
          : {}),
      })),
    [],
  );

  return (
    <CascadingFilter
      size="compact"
      label={heatmapTimezoneClosedLabel(timezone)}
      detail={detail}
      value={timezone}
      groups={groups}
      onChange={onTimezoneChange}
      ariaLabel={ariaLabel}
      className={className ?? 'w-full sm:w-[280px]'}
    />
  );
}
